import React, { FC } from 'react';
import { Tooltip } from '../Tooltip';
import { nanoid } from 'nanoid';
import { StyledSticker } from './Sticker.styles';
import { StickerProps } from './Sticker.types';
import { TrevorIcon } from "../TrevorIcon";

export const Sticker: FC<StickerProps> = ({
  size= 'medium',
  type = 'info',
  label,
  iconName,
  tooltipContent,
  ...props
}) => {
  const id = nanoid();
  return (
    <>
      <StyledSticker
        data-tooltip-id={id}
        size={size}
        type={type}
        {...props}
        // Note: The labels are not clickable
        onClick={(e: React.MouseEvent) => e.preventDefault()}
      >
        {iconName && <TrevorIcon name={iconName}/> }
        {label}
      </StyledSticker>
      {tooltipContent && <Tooltip id={id}>{tooltipContent}</Tooltip>}
    </>
  );
};
